module.exports = __webpack_public_path__ + "static/archila-ef2b3e22049268e52083a48cd2db3cd8.png";